<script>
  import { onDestroy } from 'svelte';
  import Channels from './Channels/Channels.svelte';
  import Login from '../Login.svelte';
  import { Tabs, TabList, TabPanel, Tab } from '../Common/Tabs';
  import { user, selectedChannelId } from '../../Store/store';
  import Settings from './Settings/Settings.svelte';
  import Playlist from './Playlist/Playlist.svelte';
  import { listenToChannel } from '../../Api/playlistApi';
  import TheoPlayerContainer from './TheoPlayer/TheoPlayerContainer.svelte';

  let selected;
  let unsubscribeListenToChannel;
  $: $selectedChannelId && getChannelData();

  const getChannelData = async () => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }

    unsubscribeListenToChannel = await listenToChannel($selectedChannelId, (snapShot) => {
      if (snapShot.exists) {
        selected = { ...snapShot.data(), id: snapShot.id };
      }
    });
  };

  onDestroy(async () => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
    }
  });
</script>

<div class="container">
  {#if $user}
    <div class="sidebar">
      <Channels />
    </div>
    <div class="workspace">
      {#if $selectedChannelId}
        <div class="workspace-container">
          <div class="tabs-container">
            <Tabs>
              <div class="tab-list">
                <TabList>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> list </span>
                      <span>Spilleliste</span>
                    </div>
                  </Tab>
                  <Tab main={true}>
                    <div class="tab-content">
                      <span class="material-icons icon"> settings </span>
                      <span>Innstillinger</span>
                    </div>
                  </Tab>
                </TabList>
              </div>
              <TabPanel>
                <Playlist />
              </TabPanel>
              <TabPanel>
                <Settings />
              </TabPanel>
            </Tabs>
          </div>
          <div class="preview-playlist-container">
            <header><span>publisert</span></header>
            <div class="playlist-container">
              {#if selected && selected.playlist}
                <TheoPlayerContainer {selected} />
              {/if}
            </div>
          </div>
        </div>
      {:else}
        <div class="empty">
          <p>Opprett en videostrøm</p>
        </div>
      {/if}
    </div>
  {:else}
    <Login />
  {/if}
</div>

<style src="./videoplaylistcontainer.scss">
</style>
